// import { Fence } from '@mui/icons-material'
import { invEstParams } from '../../data/fence_est_params.js'
import { productIDs } from '../../data/productConstants.js'
// eg. {splitBolt: 'ASPLTC10-EB'}
import appUtilities from '../appUtilities.js'
function getNeededInvItemList(FenceObject, elementArray) {
    const neededInvItemList = {
        invItemMap: new Map(),
        addItem(id, qty) {
            const currentQty = this.invItemMap.get(id)
            const newQty = parseInt(qty, 10)
            const summedQty = currentQty ? currentQty + newQty : newQty
            this.invItemMap.set(id, summedQty)
            appUtilities.addLogging(
                `Now the new value for ${id},
                after adding a qty of ${qty},
                is ${summedQty} `
            )
        },
        convertToWhiteInsul() {
            // complex enough figuring correct values for these items. Just switching them over if White desired
            let that = this
            function switchToWhite(old, next) {
                const qty = that.invItemMap.get(old)
                if (qty) {
                    that.invItemMap.delete(old)
                    that.addItem(next, qty)
                }
            }

            let {
                rollerInsulators,
                rollerInsulatorsWHT,
                linePostInsulators,
                linePostInsulatorsWHT,
                tPostInsulators,
                tPostInsulatorsWHT,
                tPostCap,
                tPostCapWHT,
            } = productIDs

            ;[
                [rollerInsulators, rollerInsulatorsWHT],
                [linePostInsulators, linePostInsulatorsWHT],
                [tPostInsulators, tPostInsulatorsWHT],
                [tPostCap, tPostCapWHT],
            ].forEach(([old, next]) => {
                switchToWhite(old, next)
            })
        },
    }

    //   *******************************************
    //   LOAD THE INV MAP
    //   *******************************************
    let elementCalcRpt = ''
    // let theElementsSummary = []

    elementArray.forEach(
        ({ elementID, matsID, braceID, qty: numOfElements }) => {
            // concatenate a key
            const elementArrayKey = elementID.toString() + matsID + braceID
            // console.log(elementArrayKey)

            /*           
        where do the keys of the elementArray match with the invEstParams taking the form of...eg.
        {
            key: '101',
            qty: '4',
            productID: 'IWHDCLAWB-EB',
        },
         const elementTypes = { post: 0, corner: 1, end: 2, gate: 3 }
        reflecting a corner with wood post material and wood h-brace.
        '101' and will require 4 IWHDCLAWB_EB per corner
        */

            const filteredParams = invEstParams.filter(
                ({ key }) => key === elementArrayKey
            )

            if (filteredParams && filteredParams.length) {
                //eg. multiple entries for '100'
                filteredParams.forEach(({ productID, qty: paramQty }) => {
                    let paramQtyInt = parseInt(paramQty, 10)
                    let neededQty = 0
                    let tPostCapAdjustment = 0

                    if (productID === productIDs.tPostCap) {
                        // discern if t posts involved
                        neededQty = paramQtyInt * numOfElements // first strand uses caps and all others use line insulators

                        if (FenceObject.strands > 1) {
                            tPostCapAdjustment =
                                (FenceObject.strands - 1) * numOfElements
                        }
                    } else {
                        neededQty =
                            paramQtyInt * numOfElements * FenceObject.strands
                    }

                    neededInvItemList.addItem(productID, neededQty)

                    if (tPostCapAdjustment) {
                        neededInvItemList.addItem(
                            productIDs.tPostInsulators,
                            tPostCapAdjustment
                        )
                    }

                    if (elementCalcRpt === '') {
                        // initial
                        elementCalcRpt = `
                        Element array calculations --- `
                    }

                    const strands = FenceObject.strands

                    const reportObject = {
                        elementID,
                        elementArrayKey,
                        paramQty,
                        productID,
                        neededQty,
                        strands,
                        numOfElements,
                        tPostCapAdjustment,
                    }

                    elementCalcRpt +=
                        appUtilities.readableFenceElementCalc(reportObject)
                })
            }
        }
    )
    function getTtlSplitBoltQty() {
        let ttlSplitBoltQty = FenceObject.strands * 3 // every fence has 1 gate or 2 ends = 2 bolts per strand + 1 electrical connection per strand
        ttlSplitBoltQty +=
            FenceObject.c_mats === 0 &&
            FenceObject.c_hbrace === 0 &&
            FenceObject.corners * 4 // if wood and braid braced Corners
        ttlSplitBoltQty +=
            FenceObject.e_mats === 0 &&
            FenceObject.e_hbrace === 0 &&
            FenceObject.ends * 2 // if wood and braid braced ends
        ttlSplitBoltQty += FenceObject.ends * FenceObject.strands // terminations not gates
        ttlSplitBoltQty += FenceObject.joins * FenceObject.strands * 2 // joins or termination and continue
        ttlSplitBoltQty +=
            FenceObject.gates > 0 &&
            (FenceObject.gates - 1) * FenceObject.strands + 2 // original gate accounted for at initialization of ttlSplitBoltQty
        const ttlSplitBoltQtyRpt = `\nTotal Split Bolt Qty needed is ${ttlSplitBoltQty}`
        appUtilities.addLogging(ttlSplitBoltQtyRpt)
        return ttlSplitBoltQty
    }

    neededInvItemList.addItem(
        productIDs.colorReel[FenceObject.color],
        FenceObject.reels
    )

    //  if tpost selected then no insulators and therefore screws.
    if (
        neededInvItemList.invItemMap.get(productIDs.linePostInsulators) !==
        undefined
    ) {
        neededInvItemList.addItem(
            productIDs.shortScrews,
            neededInvItemList.invItemMap.get(productIDs.linePostInsulators) * 2
        )
    }

    neededInvItemList.addItem(
        productIDs.longScrews,
        neededInvItemList.invItemMap.get(productIDs.rollerInsulators) * 2
    )

    FenceObject.kit &&
        neededInvItemList.addItem(
            productIDs.gateKit,
            FenceObject.gates * FenceObject.strands
        )

    FenceObject.i_color && neededInvItemList.convertToWhiteInsul() // can't be done until screws determined

    neededInvItemList.addItem(productIDs.leadOutWire, 1)
    neededInvItemList.addItem(productIDs.groundRodClamps, 1)
    neededInvItemList.addItem(productIDs.groundRods, 3)
    neededInvItemList.addItem(productIDs.digitalFenceTester, 1)

    // enter Reels trigger for energizer upgrade ie 12 = if more than 12 reels then 4 joule instead of default 2 joule
    FenceObject.reels > appUtilities.energizerTrigger
        ? neededInvItemList.addItem(productIDs.energizerLg, 1)
        : neededInvItemList.addItem(productIDs.energizer, 1)

    if (FenceObject.sizeFt > appUtilities.tensionKitTrigger) {
        neededInvItemList.addItem(productIDs.tensionKit, 2)
    } else {
        neededInvItemList.addItem(productIDs.tensionKit, 1)
    }

    neededInvItemList.addItem(productIDs.splitBolt, getTtlSplitBoltQty())

    // let array = [...new Set(theElementsSummary)] // theElementsSummary will have duplicates given where it was generated - restricting to unique
    // const fenceElementSummary = array.join('\r\n')

    const fenceGeneralSummaryLog = FenceObject.generalFenceDescripRpt()

    // FenceObject.clientsFenceSummary = fenceGeneralSummaryLog + fenceElementSummary

    appUtilities.addLogging(fenceGeneralSummaryLog)
    appUtilities.addLogging(elementCalcRpt)

    return neededInvItemList
}

export { getNeededInvItemList }
